import { EmployeeLiteModel } from 'api-hooks/employee';
import { Expose, Type } from 'class-transformer';
import { UserStatusEnum } from 'common/constants/enum';
import {
  CommonModel,
  CommonParamInput,
} from 'common/repositories/common.model';

// Model

export enum AgentTransactionEnum {
  debt = 'debt',
  settled = 'settled',
}

export class AgentContactModel extends CommonModel {
  name: string;
  email?: string | null;
  phone?: string | null;
  phone_2?: string | null;
  description?: string | null;
}

export class AgentSystemModel {
  @Expose({ name: 'due_period' })
  @Type(() => Number)
  duePeriod: number;

  @Expose({ name: 'transaction_limit' })
  @Type(() => Number)
  transactionLimit?: number | null;

  @Expose({ name: 'is_transaction_limited' })
  @Type(() => Boolean)
  isTransactionLimited: boolean;

  @Expose({ name: 'remaining_transaction_quota' })
  @Type(() => Number)
  remainingTransactionQuota: number;
}

export class AgentBillingModel {
  id: string;
  name: string;
  phone: string;
  phone_2?: string | null;
  address: string;
  bank: string;

  @Expose({ name: 'account_number' })
  accountNumber: string;
}

export class AgentLiteModel extends CommonModel {
  description?: string | null;
  name: string;
  address: string;
  email?: string | null;
  phone?: string | null;
  phone_2?: string | null;
  status: UserStatusEnum;

  @Expose({ name: 'created_by' })
  @Type(() => EmployeeLiteModel)
  createdBy: EmployeeLiteModel;

  @Type(() => AgentBillingModel)
  billings: AgentBillingModel[];

  @Type(() => Number)
  balance: number;

  @Type(() => AgentSystemModel)
  system: AgentSystemModel;

  @Type(() => AgentContactModel)
  contacts: AgentContactModel[];
}

export class AgentModel extends AgentLiteModel {}

// Input

export type getAgentsInput = {
  params: CommonParamInput;
};

export type getAgentInput = {
  id: string;
};

export type AgentSystemInput = {
  isTransactionLimited: boolean;
  transactionLimit?: number | null;
  duePeriod: number;
};

export type CustomerBillingInput = {
  id?: string;
  name: string;
  phone: string;
  phone_2?: string | null;
  address: string;
  bank: string;
  accountNumber: string;
};

export type AgentMutationInput = {
  // REQUIRED
  name: string;
  address: string;

  email?: string;
  phone?: string;
  phone_2?: string | null;
  system: AgentSystemInput;
  contacts: {
    id?: string;
    name: string;
    email: string;
    phone: string;
    phone_2?: string | null;
    description?: string | null;
  }[];

  description?: string | null;
};

export type AgentUpdateInput = {
  agentId: string;
  body: AgentMutationInput;
};

export type AgentDeleteInput = {
  agentId: string;
  body: {
    action: UserStatusEnum;
  };
};
